import { render, staticRenderFns } from "./PricingPageFullPage.vue?vue&type=template&id=6eb88066&"
import script from "./PricingPageFullPage.vue?vue&type=script&lang=js&"
export * from "./PricingPageFullPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports